var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"color":"transparent py-3"}},[_c('div',{staticClass:"logo-wrapper logo-align"},[_c('v-img',{attrs:{"width":_vm.logoWidth,"height":_vm.logoHeight,"src":_vm.logoSrc}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }